/**
 * MDF-242 - per-participant, per-session record that the participant
 * acknowledged the AI disclosure.
 *
 * The waiting room writes it on acknowledge; the participant active page reads
 * it so a direct link to `/participant/sessions/:id/active` cannot skip the
 * disclosure, and a reload mid-session does not re-prompt.
 *
 * The leader pages use `medley.activeSession.aiAck.<sessionId>`. This key also
 * carries the user id, because an admin can impersonate several participants of
 * the same session in one browser, and one participant's acknowledgment must
 * never count for another.
 */

function participantAiAckKey(userId: string, sessionId: string): string {
  return `medley.participantSession.aiAck.${userId}.${sessionId}`;
}

export function hasParticipantAiAck(
  userId: string | undefined,
  sessionId: string | undefined
): boolean {
  if (!userId || !sessionId) return false;
  try {
    return window.localStorage.getItem(participantAiAckKey(userId, sessionId)) === '1';
  } catch {
    return false;
  }
}

export function setParticipantAiAck(
  userId: string | undefined,
  sessionId: string | undefined
): void {
  if (!userId || !sessionId) return;
  try {
    window.localStorage.setItem(participantAiAckKey(userId, sessionId), '1');
  } catch {
    // Storage unavailable (private mode / quota): the disclosure re-shows on the
    // active page, which is the safe direction.
  }
}
